import axios from "axios";
import toast from "react-hot-toast";

const Instance = axios.create({ baseURL: process.env.REACT_APP_API });

Instance.interceptors.request.use(
  (config) => {
    config.headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Content-Type, Accept, X-Requesed-With, Origin",
      "Access-Control-Allow-Headers": "POST, GET, PUT, PATCH, OPTION, HEAD",
    };

    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      toast.error(error.response.data.message);
      localStorage.removeItem("user");
      window.location.replace("/");
    }
    return Promise.reject(error);
  }
);

export default Instance;